
import React, { useEffect, useState } from 'react';
import { Box, Card, Grid2, Tooltip, Typography } from '@mui/material';
import EditableTable from '../../../components/customTableComponent';
import { ColumnConfig, TableRowData } from '../../../types';
import { useTranslation } from 'react-i18next';
import { useGradingHistory } from '../GradingHistoryContext';
import { embryoGradingResultsDetailsSinglePatient, fetchEmbryoList, fetchEmbryoResult, Patient } from '../EmbryoGradingAi.helper';
import { ReactComponent as ViewDetailsAI } from '../../../assets/SVG/ViewDetailsAI.svg';
import ResultLoader from '../ResultLoader';
import { useAlert } from '../../../components/alertProvider';

const cardSx ={
  padding: 2,
  borderRadius: 4,
  backgroundColor: '#FFFFFF',
  border: '1px solid #F0F0F0',
  position: 'relative',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  ml:0.5
};



const headerSx = {
  fontFamily: 'Montserrat',
  fontWeight: 700,
  fontSize: '16px',
  color: '#232323',
};

const subHeaderSx = {
  fontFamily: 'Montserrat',
  fontWeight: 400,
  fontSize: '14px',
  color: '#5A8AEA',
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  cursor: 'pointer',
};


interface EmbryoGradingResultRow extends TableRowData {
  embryoId: string | number;
  aiGeneratedGrade: string | number;
  manualOverrideGrade: string | number;
}

const HistoryTable: React.FC = () => {
  const [tableData, setTableData] = useState<EmbryoGradingResultRow[]>([]);
  const { t: tAiGrading } = useTranslation('aiGrading_config');
  const columns: ColumnConfig[] = [
    { field: 'embryoId', headerName: tAiGrading('embryoId', { defaultValue: 'Embryo ID' }), type: 'text', editable: false },
    { field: 'aiGeneratedGrade', headerName: tAiGrading('aiGeneratedGrade', { defaultValue: 'AI Generated Grade' }), type: 'text', editable: false },
    { field: 'manualOverrideGrade', headerName: tAiGrading('manualOverrideGrade', { defaultValue: 'Manual Override Grade' }), type: 'text', editable: false },
  ];
  const {  toggleResultAvailable , selectedResultFromResultLList, setShowFullResult , setSelectedEmbryosGrading , setSelectedEmbryoResult , setSelectedEmbryoForGrading , selectedPatientForGrading} = useGradingHistory();

  const { addAlert } = useAlert();

  useEffect(() => {

    if (selectedResultFromResultLList && selectedResultFromResultLList.id) {
      embryoGradingResultsDetailsSinglePatient({ history_id: selectedResultFromResultLList.id })
        .then((res) => {
          if (Array.isArray(res)) {
            setTableData(res.map((item) => {
              const percentage = typeof item.result_percentage === 'number'
                ? item.result_percentage.toFixed(2)
                : parseFloat(item.result_percentage).toFixed(2);
              return {
                id: item.id,
                embryoId: `${item.embryo_number}`,
                aiGeneratedGrade: `${percentage} ( ${item.result_grade} )`,
                manualOverrideGrade: item.manual_override_grade ? `${percentage} ( ${item.manual_override_grade} )` : '-',
              };
            }));
          } else {
            setTableData([]);
          }
        })
        .catch(() => {
          setTableData([]);
        });
    } else {
      setTableData([]);
    }

  }, [selectedResultFromResultLList]);



  // get Embryo List and 1st Embryo Result for selected patient
  const getEmbryoList = (data: Patient) => {
    fetchEmbryoList(
      data,
      setSelectedEmbryosGrading,
      setSelectedEmbryoResult,
      addAlert,
      fetchEmbryoResult,
      setSelectedEmbryoForGrading,
      tAiGrading
    );
  };



  const handleViewDetails = async() => {
    setShowFullResult(true);

    if (selectedResultFromResultLList?.is_result_available && selectedResultFromResultLList?.cycle_id) {
      if (selectedResultFromResultLList.cycle_id && selectedResultFromResultLList.is_result_available && selectedPatientForGrading) {
        await getEmbryoList(selectedPatientForGrading);
        toggleResultAvailable(true); // off loader
      } else {
        toggleResultAvailable(false); // loader on
      }
    }

  };














  return (
    <Card elevation={0} sx={cardSx}>

      {
        !selectedResultFromResultLList?.is_result_available ? (
          <>      
            <Grid2 size={12}  height={'100%'}>
              <ResultLoader title={tAiGrading('waitwhileGeneratingAIEmbryoGrading', { defaultValue: 'Please wait while generating AI embryo grading...' })} />
            </Grid2>              
          </>

        ) : (
         
          <> 
            <Box display="flex" justifyContent="space-between" alignItems="center" pb={1.5}>
        
              <Typography sx={headerSx}>
                {tAiGrading('result', { defaultValue: 'Result' })} - {selectedResultFromResultLList?.index}
              </Typography>
              <Tooltip title={tAiGrading('seeFullResult', { defaultValue: 'See Full Result' })} arrow>
                <Typography sx={subHeaderSx} onClick={handleViewDetails}>
                  <ViewDetailsAI />  {tAiGrading('seeFullResult', { defaultValue: 'See Full Result' })}
                </Typography>
              </Tooltip>
            </Box>
            
         
            <EditableTable columns={columns} data={tableData} actionType='none' /> 
          </>

        )


      }




    </Card>
  );
};

export default HistoryTable;